import { clearLoggedInCookie, hasLoggedInCookie, urlApiProfile, } from "./api.js";
import { ApiError } from "./util.js";
export function recoverExpiredSession(error, key) {
    if (key !== urlApiProfile ||
        !(error instanceof ApiError) ||
        error.status !== 401 ||
        !hasLoggedInCookie()) {
        return false;
    }
    clearLoggedInCookie();
    return true;
}
